import React from 'react'
import Retour from '../components/Retour'

function Zeria() {
  return (
    <div>
        <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
        <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Gaspard est le dernier homme sur Terre. Zeria, son petit-fils, est le premier être humain né sur Mars. Gaspard lui raconte sa vie, ses peurs, ses amours… dans l’espoir que Zeria vienne le voir avant de mourir. Zeria serait le premier être humain à revenir sur Terre sans l’avoir jamais connue…</p>
        </div>
        <div style={{textAlign:"center"}}> <Retour /></div>
    </div>
  )
}

export default Zeria

